// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"ba9c3da2","259":"7782628a","384":"ba9c3da2","587":"bf6c172b","632":"ba9c3da2","836":"ec288738","907":"eeb017bf","940":"bf27bb9f","950":"864476d7","956":"ba9c3da2"}[chunkId] + ".chunk.css";
};